import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { LicenseManager } from '@ag-grid-enterprise/core'
import 'ag-grid-enterprise'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
LicenseManager.setLicenseKey(process.env.AGGRID_LICENSE_KEY)

const AgGrid = ({ ...props }) => {
  const modules = AllModules

  return <AgGridReact modules={modules} {...props} />
}

const mapStateToProps = (state) => ({ ...state })
export default connect(mapStateToProps)(withRouter(AgGrid))



// WEBPACK FOOTER //
// ./src/components/ag_grid/AgGrid.js